import { useSyncExternalStore } from "react";

/**
 * Tema dell'interfaccia: chiaro di default, scuro su richiesta o "come il
 * sistema". È una preferenza del dispositivo, quindi resta nel browser; lo
 * script in index.html la applica prima del primo paint per evitare il lampo.
 */
export type ThemePref = "light" | "dark" | "system";

const KEY = "kipo-theme";
const media = () => window.matchMedia("(prefers-color-scheme: dark)");
const listeners = new Set<() => void>();

function read(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === "dark" || v === "system" ? v : "light";
  } catch {
    return "light";
  }
}

function apply(pref: ThemePref) {
  const dark = pref === "dark" || (pref === "system" && media().matches);
  const root = document.documentElement;
  root.dataset.theme = dark ? "dark" : "light";
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", dark ? "#18191C" : "#FFFFFF");
}

export function setThemePref(pref: ThemePref) {
  try {
    localStorage.setItem(KEY, pref);
  } catch {
    /* preferenza solo per questa sessione */
  }
  apply(pref);
  listeners.forEach((l) => l());
}

media().addEventListener("change", () => read() === "system" && apply("system"));
window.addEventListener("storage", (e) => {
  if (e.key !== KEY) return;
  apply(read());
  listeners.forEach((l) => l());
});

export function useThemePref(): ThemePref {
  return useSyncExternalStore(
    (l) => (listeners.add(l), () => listeners.delete(l)),
    read,
  );
}

export const THEME_OPTIONS: { value: ThemePref; label: string; icon: "sun" | "moon" | "monitor" }[] = [
  { value: "light", label: "Chiaro", icon: "sun" },
  { value: "dark", label: "Scuro", icon: "moon" },
  { value: "system", label: "Automatico", icon: "monitor" },
];
